import React from 'react';
import NumberFormat from 'react-number-format';

interface NumberComponentProps {
  inputRef?: (instance: any) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  [key: string]: any;
}

const NumberComponent: React.FC<NumberComponentProps> = (props) => {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      // prefix="$"
    />
  );
};

export default NumberComponent;
